<template>
  <main
    role="main"
    class="col content-spacing"
    style="padding: 0.5rem 0; max-width: 88% !important;"
  >
    <PageHeader pageTitle="Panorama Custom">
      <div style="display: flex; gap: 0.5rem;">
        <b-form-select
          v-model="customOptionA"
          :options="filteredOptions('A')"
          class="form-control"
          style="color: green;"
        >
          <template #first>
            <b-form-select-option :value="null"
              >Selecione a opção A</b-form-select-option
            >
          </template>
        </b-form-select>
        <b-form-select
          v-model="customOptionB"
          :options="filteredOptions('B')"
          class="form-control"
          style="color: blue;"
        >
          <template #first>
            <b-form-select-option :value="null"
              >Selecione a opção B</b-form-select-option
            >
          </template>
        </b-form-select>
        <b-form-select
          v-model="customOptionC"
          :options="filteredOptions('C')"
          class="form-control"
          style="color: purple;"
        >
          <template #first>
            <b-form-select-option :value="null"
              >Selecione a opção C</b-form-select-option
            >
          </template>
        </b-form-select>

        <SelectYear v-model="referenceYear" />

        <!-- TODO: Criar um componente separado para filtro de status de instalação  -->
        <b-form-select
          v-model="filter.status"
          :options="installationStatusOption"
          class="form-control mr-3"
          v-if="
            customOptionA && customOptionB && customOptionC && referenceYear
          "
        >
          <template #first>
            <b-form-select-option :value="null"
              >Selecione um status</b-form-select-option
            >
          </template>
        </b-form-select>

        <SelectBillingStatus
          v-model="filter.billingStatus"
          v-if="
            customOptionA && customOptionB && customOptionC && referenceYear
          "
        />

        <GenericSearchInput
          v-if="
            customOptionA && customOptionB && customOptionC && referenceYear
          "
          v-model="filter.search"
        />

        <BaseButtonComponent
          @click="getAll()"
          variant="primary-action"
          :disabled="
            !(customOptionA && customOptionB && customOptionC && referenceYear)
          "
        >
          Buscar
        </BaseButtonComponent>
      </div>
    </PageHeader>
    <loading-list v-if="isLoading"></loading-list>
    <div
      class="d-flex justify-content-between flex-column h-100"
      v-if="!isLoading && Object.entries(panoramaList).length !== 0"
    >
      <Table style="margin-top: 1rem;" class="panorama-custom-table">
        <TableHeader>
          <TableRow>
            <TableHead
              v-for="(month, index) of monthList"
              :key="`${month}_${index}`"
            >
              {{ month }}
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow
            v-for="(consumerBillItem, index) of Object.entries(panoramaList)"
            :key="`${consumerBillItem}_${index}`"
          >
            <TableCell>
              <span>{{ consumerBillItem[0] }}</span>
            </TableCell>
            <TableCell>
              <span>{{
                consumerBillItem[1].length
                  ? getUserName(consumerBillItem[1])
                  : ''
              }}</span>
            </TableCell>
            <TableCell>
              <span>{{
                consumerBillItem[1].length
                  ? getConsumerBillItemStatus(consumerBillItem[1])
                  : ''
              }}</span>
            </TableCell>
            <TableCell>
              <PanoramaCustomTableCell
                :consumerBillItem="consumerBillItem[1]"
                :monthIndex="monthsIndex.Janeiro"
                :propertyNameA="propertyNameA"
                :propertyNameB="propertyNameB"
                :propertyNameC="propertyNameC"
              />
            </TableCell>
            <TableCell>
              <PanoramaCustomTableCell
                :consumerBillItem="consumerBillItem[1]"
                :monthIndex="monthsIndex.Fevereiro"
                :propertyNameA="propertyNameA"
                :propertyNameB="propertyNameB"
                :propertyNameC="propertyNameC"
              />
            </TableCell>
            <TableCell>
              <PanoramaCustomTableCell
                :consumerBillItem="consumerBillItem[1]"
                :monthIndex="monthsIndex.Março"
                :propertyNameA="propertyNameA"
                :propertyNameB="propertyNameB"
                :propertyNameC="propertyNameC"
              />
            </TableCell>
            <TableCell>
              <PanoramaCustomTableCell
                :consumerBillItem="consumerBillItem[1]"
                :monthIndex="monthsIndex.Abril"
                :propertyNameA="propertyNameA"
                :propertyNameB="propertyNameB"
                :propertyNameC="propertyNameC"
              />
            </TableCell>
            <TableCell>
              <PanoramaCustomTableCell
                :consumerBillItem="consumerBillItem[1]"
                :monthIndex="monthsIndex.Maio"
                :propertyNameA="propertyNameA"
                :propertyNameB="propertyNameB"
                :propertyNameC="propertyNameC"
              />
            </TableCell>
            <TableCell>
              <PanoramaCustomTableCell
                :consumerBillItem="consumerBillItem[1]"
                :monthIndex="monthsIndex.Junho"
                :propertyNameA="propertyNameA"
                :propertyNameB="propertyNameB"
                :propertyNameC="propertyNameC"
              />
            </TableCell>
            <TableCell>
              <PanoramaCustomTableCell
                :consumerBillItem="consumerBillItem[1]"
                :monthIndex="monthsIndex.Julho"
                :propertyNameA="propertyNameA"
                :propertyNameB="propertyNameB"
                :propertyNameC="propertyNameC"
              />
            </TableCell>
            <TableCell>
              <PanoramaCustomTableCell
                :consumerBillItem="consumerBillItem[1]"
                :monthIndex="monthsIndex.Agosto"
                :propertyNameA="propertyNameA"
                :propertyNameB="propertyNameB"
                :propertyNameC="propertyNameC"
              />
            </TableCell>
            <TableCell>
              <PanoramaCustomTableCell
                :consumerBillItem="consumerBillItem[1]"
                :monthIndex="monthsIndex.Setembro"
                :propertyNameA="propertyNameA"
                :propertyNameB="propertyNameB"
                :propertyNameC="propertyNameC"
              />
            </TableCell>
            <TableCell>
              <PanoramaCustomTableCell
                :consumerBillItem="consumerBillItem[1]"
                :monthIndex="monthsIndex.Outubro"
                :propertyNameA="propertyNameA"
                :propertyNameB="propertyNameB"
                :propertyNameC="propertyNameC"
              />
            </TableCell>
            <TableCell>
              <PanoramaCustomTableCell
                :consumerBillItem="consumerBillItem[1]"
                :monthIndex="monthsIndex.Novembro"
                :propertyNameA="propertyNameA"
                :propertyNameB="propertyNameB"
                :propertyNameC="propertyNameC"
              />
            </TableCell>
            <TableCell>
              <PanoramaCustomTableCell
                :consumerBillItem="consumerBillItem[1]"
                :monthIndex="monthsIndex.Dezembro"
                :propertyNameA="propertyNameA"
                :propertyNameB="propertyNameB"
                :propertyNameC="propertyNameC"
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
    <empty-list
      v-if="!isLoading && Object.entries(panoramaList).length === 0"
    />
  </main>
</template>

<script>
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../ui/table';
import { PanoramaCustomTableCell } from './components';
import { PageHeader } from '../../ui/page-header';
import { Api } from '../../vue/api';
import helpers from '../../vue/helpers';
import {
  formatInstallationStatusToPtBr,
  removeNullProperties,
} from '../../utils/index';
import { SelectBillingStatus } from '../../modules/invoice/components';
import { SelectYear } from '../../ui/selects';
import { GenericSearchInput } from '../../ui/inputs';
import { BaseButtonComponent } from '../../ui/buttons';

const API = new Api();

export default {
  name: 'panorama-custom',
  components: {
    Table,
    TableRow,
    TableBody,
    TableHead,
    TableCell,
    TableHeader,
    PageHeader,
    PanoramaCustomTableCell,
    SelectBillingStatus,
    SelectYear,
    GenericSearchInput,
    BaseButtonComponent,
  },
  computed: {
    billingStatus() {
      return this.filter.billingStatus;
    },
    status() {
      return this.filter.status;
    },
    search() {
      return this.filter.search;
    },
  },
  watch: {
    billingStatus() {
      this.handleFilterList('billingStatus', 'billingStatus');
    },
    status() {
      this.handleFilterList('status', 'status');
    },
    search() {
      this.handleFilterList('search', 'search');
    },
  },
  data() {
    return {
      isLoading: false,
      customOptionA: null,
      customOptionB: null,
      customOptionC: null,
      propertyNameA: null,
      propertyNameB: null,
      propertyNameC: null,
      options: [
        { value: 'cbi.dueDate', text: 'Data Vence Veins' },
        { value: 'cc.due_date_distributor', text: 'Data Vence Distrib.' },
        { value: 'cbi.date_to_paid', text: 'Data Boleto Pago' },
        {
          value: 'cbi.send_boleto_date',
          text: 'Data Boleto Enviado',
        },
        { value: 'cbi.boletoVeins', text: '(R$) Boleto Veins' },
        { value: 'cbi.totalCredit', text: '(R$) Crédito total' },
        { value: 'cbi.totalEconomy', text: '(R$) Economia' },
        {
          value: 'cbi.repasseUsinaValue',
          text: '(R$) Repasse Usina',
        },
        {
          value: 'cbi.grossIncomeValue',
          text: '(R$) Receita Veins',
        },
        {
          value: 'cbi.distributorInvoice',
          text: '(R$) Fatura Distrib.',
        },
        {
          value: 'cc.total_consumption',
          text: '(kWh) Cons. Total',
        },
        {
          value: 'cc.distribution_energy',
          text: '(kWh) Ene. Dist.',
        },
        {
          value: 'cc.compensated_energy',
          text: '(kWh) Ene. Comp.',
        },
        {
          value: 'cc.accumulated_balance',
          text: '(kWh) Saldo Ac.',
        },
        {
          value: 'cbi.percentagePowerPlant',
          text: '(%) Repasse Usina',
        },
        {
          value: 'cbi.guaranteedDiscount',
          text: '(%) Desc. garantido',
        },
        {
          value: 'cbi.grossIncomePercentage',
          text: ' (%) Receita Veins',
        },
        {
          value: 'cbi.nossoNumero',
          text: 'Ref. Boleto V2',
        },
        {
          value: 'cbi.seuNumero',
          text: 'Ref. Boleto V3 Pix',
        },
        { value: 'cbi.ov', text: 'Ref. OV Financeira' },
        { value: 'cbi.ov_fiscal', text: 'Ref. OV Fiscal' },
      ],
      panoramaList: [],
      fQuery: '',
      monthList: [
        'Instalação',
        'Nome',
        'Status',
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
      monthsIndex: {
        Janeiro: 0,
        Fevereiro: 1,
        Março: 2,
        Abril: 3,
        Maio: 4,
        Junho: 5,
        Julho: 6,
        Agosto: 7,
        Setembro: 8,
        Outubro: 9,
        Novembro: 10,
        Dezembro: 11,
      },
      referenceYear: null,
      installationStatusOption: [
        { value: 'IN_ANALYSIS', text: 'Em análise' },
        { value: 'WAITING_APPROVAL', text: 'Aguardando aprovação' },
        { value: 'REFUSED', text: 'Recusada' },
        { value: 'WAITING_CONNECTION', text: 'Aguardando conexão' },
        { value: 'CONNECTING', text: 'Em Conexão' },
        { value: 'ACTIVE', text: 'Ativo' },
        { value: 'PENDING_INFORMATION', text: 'Informações Pendentes' },
        { value: 'INACTIVE', text: 'Inativo' },
        { value: 'REJECTED', text: 'Rejeitada' },
        { value: 'INACTIVATION_REQUESTED', text: 'Inativação solicitada' },
      ],
      filter: {
        status: null,
        search: null,
        billingStatus: null,
      },
    };
  },
  methods: {
    /**
     * @typedef {Object} SelectOptions
     * @property {string} value
     * @property {string} text
     */
    /**
     * @param {string} selectedOption
     * @return {function(): SelectOptions}
     */
    filteredOptions(selectedOption) {
      switch (selectedOption) {
        case 'A':
          return this.options.filter(
            option =>
              option.value !== this.customOptionB &&
              option.value !== this.customOptionC,
          );
        case 'B':
          return this.options.filter(
            option =>
              option.value !== this.customOptionA &&
              option.value !== this.customOptionC,
          );
        case 'C':
          return this.options.filter(
            option =>
              option.value !== this.customOptionA &&
              option.value !== this.customOptionB,
          );
        default:
          return this.options;
      }
    },
    /**
     * @param {string} customOptionA
     * @param {string} customOptionB
     * @param {string} customOptionC
     * @return {function(): void}
     */
    setPropertiesName(customOptionA, customOptionB, customOptionC) {
      const regex = /(cbi\.|cc\.)/;
      this.propertyNameA = customOptionA.replace(regex, '');
      this.propertyNameB = customOptionB.replace(regex, '');
      this.propertyNameC = customOptionC.replace(regex, '');
    },
    /**
     * @return {function(): string}
     */
    getUserName(consumerBillItemList) {
      for (let i = 0; i < consumerBillItemList.length; i++) {
        if (consumerBillItemList[i] && consumerBillItemList[i].name) {
          return consumerBillItemList[i].name.length > 31
            ? `${consumerBillItemList[i].name.substring(0, 31)}...`
            : consumerBillItemList[i].name;
        }
      }
    },
    /**
     * @return {function(): string}
     */
    getConsumerBillItemStatus(consumerBillItemList) {
      for (let i = 0; i < consumerBillItemList.length; i++) {
        if (consumerBillItemList[i] && consumerBillItemList[i].status) {
          return formatInstallationStatusToPtBr(consumerBillItemList[i].status);
        }
      }
    },
    /**
     * Método para filtrar a lista
     * @return {function(): void}
     */
    async handleFilterList(queryProp, searchProp) {
      this.$route.query[queryProp] = this.filter[searchProp];
      await this.getAll();
    },
    /**
     * @return {function(): void}
     */
    async getAll() {
      this.isLoading = true;
      try {
        this.setPropertiesName(
          this.customOptionA,
          this.customOptionB,
          this.customOptionC,
        );
        const searchObject = removeNullProperties(this.$route.query);
        const { model } = await API.post('/execute', {
          path:
            `/installation/panorama/custom/${this.customOptionA}/${this.customOptionB}/${this.customOptionC}/${this.referenceYear}` +
            helpers.toQueryString(searchObject),
          method: 'get',
        });

        this.panoramaList = model;
      } catch (error) {
        this.$toast.error(helpers.getFirstError(error));
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.panorama-custom-table {
  display: block;
  max-height: 88vh !important;
  height: auto !important;

  th:first-child,
  td:first-child {
    position: sticky;
    left: 0;
    background-color: #e7e7e7;
  }

  td:nth-child(2),
  th:nth-child(2) {
    position: sticky;
    left: 6rem;
    background-color: #e7e7e7;
  }

  td:nth-child(3),
  th:nth-child(3) {
    position: sticky;
    left: 24rem;
    background-color: #e7e7e7;
  }

  tr:nth-child(odd) td:nth-child(-n + 3) {
    background-color: #e7e7e7;
  }

  tr:nth-child(even) td:nth-child(-n + 3) {
    background-color: #f2f2f2;
  }
}
.panorama-custom-table-cell {
  display: flex;
  gap: 0.2rem;
}

.property-a {
  color: green;
}

.property-b {
  color: blue;
}

.property-c {
  color: purple;
}
</style>
